import { toast, TypeOptions } from "react-toastify";

export const notification = (message: string, type: TypeOptions) => {
  const width = window.innerWidth;
  const position = width < 680 ? "top-center" : "top-left";
  return toast(message, {
    position: position,
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    type: type,
  });
};
